import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '../../assets/profil.png'


const _hoisted_1 = { class: "pannel flex flex-column" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex align-items-center p-3",
  style: {"border-bottom":"1px solid #eaeef0"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "ci-icon-lightbulb text-primary-blue" }),
  /*#__PURE__*/_createElementVNode("span", { class: "flex app-label text-primary-blue font-bold ml-2" }, " Le saviez-vous ? ")
], -1)
const _hoisted_3 = { class: "p-3 flex flex-column justify-content-evenly gap-3 h-full" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-content-start align-items-center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-right":"-15px","height":"35px"},
  class: "border-circle",
  src: _imports_0,
  alt: "ellipse1"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-right":"-15px","height":"35px"},
  class: "border-circle",
  src: _imports_0,
  alt: "ellipse2"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-right":"-15px","height":"35px"},
  class: "border-circle",
  src: _imports_0,
  alt: "ellipse3"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-right":"-15px","height":"35px"},
  class: "border-circle",
  src: _imports_0,
  alt: "ellipse4"
}, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "round-number flex align-items-center justify-content-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "app-label-small text-primary-blue font-bold" }, "+30", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "flex app-label text-gray-D1 font-bold ml-5"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "app-label text-gray-l1 font-bold" }, " Vous pouvez souscrire à une offre groupée de Garantie de Service & Maintenance de votre logement. "),
  /*#__PURE__*/_createElementVNode("span", { class: "app-label text-gray-l1 font-bold" }, " Parlez-en à votre Syndic de Copropriété. Cette offre est plus avantageuse. ")
], -1)
const _hoisted_14 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.projectUserCount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            (!_ctx.projectUserCount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
              : _createCommentVNode("", true),
            (_ctx.projectUserCount)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.projectUserCount) + " personnes de votre immeuble utilisent Ubiant. ", 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_app_button, {
          buttonType: "secondary",
          buttonSize: "m",
          buttonText: "Découvrir l’offre",
          isDisabled: false,
          onClick: _ctx.onClick
        }, null, 8, ["onClick"])
      ])
    ])
  ]))
}